export default {
  title: {
    login: "%{school} - Kirish",
    registration: "%{school} - Ro'yxatdan o'tish",
    subjects: "%{school} - Fanni tanlash",
    subject: "%{school} - Fan",
    offer: "%{school} - Taklif",
    home: "%{school} - Shaxsiy sahifa",
    dictionary: "%{school} - Lug'at",
    events: "%{school} - Darslar",
    news: "%{school} - Yangiliklar",
    profile: "%{school} - Profil",
    learn: "%{school} - Ta'lim",
    pay: "%{school} - Fan uchun to'lov",
    checkInSystem: "Email-ingizni ko'rsating",
    setPassword: "Kirish uchun parolingizni tering.",
    createAccount: " Akkauntingiz ma'lumotlarini ko'rsating/yangilang.",
  },
  authCheckEmail: {
    title: "Elektron pochta manzilingizni kiriting",
    emailCaption: "Elektron manzil",
    continue: "Davom ettirish",
    or: "yoki",
  },
  authPassword: {
    title: "Akkauntingizga kiring",
    inputCaption: "Parol",
    placeholder: "Parolni kiriting",
    forgot: "Parolni unutdingizmi?",
    submit: "Kirish",
  },
  authRegistration: {
    title: "Akkauntni ro'yxatdan o'tkazish",
    name: "Ism",
    phone: "Telefon raqamingiz",
    password: "Parol o'ylab toping",
    confirmPassword: "O'ylangan parolni takrorlang",
  },
  totalError: "Voy, nimadir noto'g'ri ketdi!",
  subjectChangeError: "Fanni almashtirib bo'lmadi. Iltimos, qayta urinib ko'ring yoki maktabingiz bilan bog'laning.",
  email: "Email",
  personalLink: "Shaxsiy havola",
  login: "Login",
  name: "Ism",
  firstLastName: "Familiya va ism",
  phone: "Telefon",
  formatPhone: "998... formatida telefon raqamingiz", // todo for leader-online
  aboutMe: "Men haqimda",
  fullAge: "Yoshingiz (to‘liq)",
  errorAge: "noto'g'ri yosh",
  notNumber: "Qiymat raqam bo'lishi kerak",
  registration: "Ro'yxatdan o'tish",
  password: "Parol",
  currentPassword: "Joriy parol",
  newPassword: "Yangi parol",
  confirmPassword: "Parolni takrorlang",
  confirmNewPassword: "Yangi parolni takrorlang",
  forgotPassword: "Parolni unutdingizmi?",
  passwordsMatch: "Parollar mos tushmayapti",
  resetPassword: "Parol muvaffaqiyatli o'chirildi, elektron pochtangizni tekshiring.",
  resetConfirm: "Parolni o'chirishni xohlaysizmi?",
  enter: "kirish",
  studentEnter: "O'quvchilar uchun kirish",
  check: "Keyingisi",
  signInWithGoogle: "Google orqali kirish",
  emailIsNotRegistered: "Bunday manzilli foydalanuvchi mavjud emas",
  logout: "Chiqish",
  online: "onlayn",
  offline: "oflayn",
  cancel: "Bekor qilish",
  yes: "Ha",
  no: "Yo'q",
  course: "Kurs",
  dictionary: "Lug'at",
  events: "Darslar",
  news: "Yangiliklar",
  words: "So'zlar",
  wordsAreHere: "Bu so'zlar bu yerda joylashgan:",
  allWords: "Barcha so'zlar",
  phrases: "Iboralar",
  videos: "Video",
  exercises: "Mashqlar",
  theory: "Nazariya",
  theoryAlt: "Kospekt",
  theoryAdditionalFile: "Qo'shimcha faylni yuklab olish (%{filename})",
  topic: "Topik",
  lesson: "Dars",
  lessons: "Darslar",
  profile: "Profil",
  orders: "Haridlar",
  payment: "To'lov",
  leaderboard: "Liderlar",
  leaderboardPerDay: "Bugungi rahbarlar",
  time: "Vaqt",
  points: "Ballar",
  myPoints: "Butun davr bo'yicha ballarim",
  coins: "Tangalar",
  courses: "Mening kurslarim",
  loading: "Yuklash...",
  noTheory: "Ushbu dars uchun nazariy ma'lumotlar yo'q",
  startTraining: "Mashqni boshlash",
  chat: {
    // === chat list / dialog additions ===
    startDialogTitle: "Chatni boshlash",
    startDialogTooltip: "Yangi suhbat yaratish",
    messages: "Xabarlar",
    unreadOnly: "Faqat o'qilmaganlar",
    delete: "O'chirish",
    send: "Yuborish",
    sendHelper: "Xabarni yuborish uchun Ctrl+Enter tugmasini bosing",
    close: "Yopish",
    profile: "Profil",
    lastActivity: "Oxirgi faollik",
    status: "Holat",
    jobTitle: "Lavozim",
    tabLabel: "Chat",
    lastOnline: {
      time: "Oxirgi marta %{date} da onlayn bo‘lgan",
      weekday: "Oxirgi marta %{date} da onlayn bo‘lgan",
      dayMonth: "Oxirgi marta %{date} onlayn bo‘lgan",
      monthYear: "Oxirgi marta %{date} da onlayn bo‘lgan",
    },
    read: "O'qing",
    errors: {
      wrongFormatting: "Xabar noto'g'ri formatlangan",
    },
  },
  branches: "Mavzular",
  easy: "Oson",
  expert: "Ekspert",
  wordToLearn: "Keyinroq o'rganish",
  iKnowWord: "Men bu so'zni bilaman",
  videoVocabulary: "Video leksika",
  markVideoWatched: "Ko‘rilgan deb belgilash",
  videoWatched: "Ko‘rilgan",
  passed: "o'tilgan",
  unsupportedExercise: "Bu turdagi mashqni (%{type}) hali bajarib bo'lmaydi",
  changeCourse: "Kursni almashtirish",
  currentCourse: "Joriy kurs",
  allSubjects: "Barcha fanlar",
  all: "Barchasi",
  subject: "Fanlar",
  group: "Guruh",
  start: "Boshlash",
  chooseSubject: "O'rganishni xohlagan fanni tanlang",
  hourValue: "%{value} ч",
  completed: "Yakunlandi",
  notCompleted: "Yakunlanmadi",
  paidBranch: "Bu mavzu pulli. Iltimos,  o'rganish uchun uni sotib oling.",
  buyBranch: "Mavzuni %{price} %{currency} ga sotib olish",
  paidSubject: "Bu fan pulli. Iltimos,  o'rganish uchun uni sotib oling.",
  buySubject2: "Fanni %{price} %{currency} ga sotib olish",
  decksItemNotOpen: "Ushbu darsni ochish uchun siz avvalgi darsdan o'tishingiz kerak",
  decksItemNotPurchasedBranch: "The topic of this lesson is blocked",
  decksItemNotOpenLevel: "Darsni ochish uchun oldingi darajadan o'ting",
  decksItemNotOpenBranch: "Ushbu darsni ochish uchun siz avvalgi mavzudan o'tishingiz kerak",
  deckAccessDenied: "Ushbu dars siz uchun hali mavjud emas",
  openOnDate: "ochiladi %{date}",
  levelAccessIsDenied: "Ushbu darajadagi materiallar siz uchun mavjud emas",
  youAreDeactivated: "Akkauntingiz o'chirilgan, iltimos, maktabingiz bilan bog'laning",
  youAreDeactivatedShort: "Sizning akkauntingiz o'chirilgan",
  youAreHaveNotPaidOffers: "Sizda to'lanmagan takliflaringiz mavjud",
  yourCertificates: "Sizning sertifikatlaringiz",
  emptyDeck: "Dars bo'sh",
  nextDeck: "Keyingi dars",
  next: "Keyingisi",
  proceed: "Davom ettirish",
  skip: "O'tkazib yuborish",
  more: "Yana",
  exit: "Chiqish",
  details: "Batafsil",
  go: "O'tish",
  profileEdit: "Profilni tahrirlash",
  userInfo: "Foydalanuvchi haqida ma'lumot",
  of: "dan",
  back: "Orqaga",
  levelPackExist: "Sizda ushbu darajalar to'plami mavjud",
  awaitingPayment: "To'lovni kutmoqda",
  bought: "Sotib olingan",
  boughtUntilDate: "%{endDate} gacha sotib olingan",
  availableUntilDate: "%{endDate} gacha kirishingiz mavjud",
  showMore: "ko'proq ko'rsatish",
  hide: "o'ramoq",
  communication: "Maktab bilan bog'lanish",
  askQuestion: "Savol berish",
  noDescription: "Tavsiflash mavjud emas",
  description: "Tavsif:",
  onePerMonth: "Oylik obuna",
  semiannually: "Oltita oylik obuna",
  onceAYear: "Yillik obuna",
  stopSubscribe: "Stop Subscribe",
  enable: "Enable Subscribe",
  expired: "Expired",
  buySubject: "fanni sotib olish",
  buyOffer: "Sotib oling",
  subscribeOffer: "Subscribe offer",
  firstPayment: "Yangi to'lov",
  accessDaysWarning: "%{smart_count} kun qoldi ||||%{smart_count} kun qoldi",
  accessDemoDaysWarning: "Demo: %{smart_count} kun qoldi |||| Demo: %{smart_count} kun qoldi",
  accessDemoButton: "Demo kirish",
  closeButton: "Yopish",
  existOffer: "There is already an unpaid offer",
  loginInProcess: "Tizimga kirish davom etmoqda...",
  done: "Tugallangan:",
  Levels: {
    empty: "Bu kursda hozircha mavjud darajalar yo‘q.",
    name: "Daraja:",
  },
  Decks: {
    scormPass: "Darsga yoziling",
    proceed: "O'rganishni boshlang'ish",
    stayHere: "Bu yerda qol",
  },
  Exercises: {
    tabTitle: "Mashqlar",
    skip: "Keyingi",
    check: "Tekshirish",
    examCheck: "Yuborish",
    typeAnswer: "Javobingizni kiriting",
    next: "Keyingisi",
    rightAnswerWas: "To'g'ri javob:",
    showRightAnswer: "To'g'ri javobni ko'rsating",
    rightAnswer: "To'g'ri javob:",
    congratulation: "Tabriklaymiz!",
    congratText: "Siz ushbu darsga oid barcha mashqlarni o'rgandingiz!",
    wrongAnswer: "Sizning javobingiz noto'g'ri",
    answerSaved: "Javob saqlandi",
    commentToAnswer: "Tanlangan javobga izoh:",
    appendix: {
      pdf: {
        tooltipButton: "Qo'shimcha materiallar",
      },
    },
    type13: {
      title: "Ochiladigan ro'yxatdan to'g'ri so'zni tanlab, bo'sh joylarni to'ldiring.",
    },
    type12: {
      title: "Qo'shimcha ma'lumot bilan tanishib chiqing",
    },
    type11: {
      title: {
        select: "To'g'ri javobni tanlang",
        keyboard: "To'g'ri javobni yozing",
      },
    },
    type9: {
      title: {
        select: "Kerakli so'zni tanlab, bo'shliqlarni to'ldiring",
        keyboard: "Bo'shliqlarni to'ldiring",
      },
    },
    type8: {
      title: "Juftlarni toping",
    },
    type7: {
      title: {
        text: "Javobingizni yozing",
        audio: "Audio javobingizni yozing",
      },
      recordingIsNotSupported: "Ovoz yozish brauzeringiz tomonidan qo'llab-quvvatlanmaydi",
      audioRecordingError: "Ovoz yozishda xatolik: ",
      inputLabel: "Sizning javobingiz",
      addPhotoVideo: "Rasm/video qo'shing (%{maxCount} donagacha)",
      addPhoto: "Rasm qo'shing (%{maxCount} donagacha)",
      cameraInitialization: "Ishga tushirish...",
      change: "O'zgartirish",
      codeToApprove: "Parol",
      homework: {
        teacherData: {
          audio: "O'qituvchining audio izohi",
          audioComment: "O'qituvchining ovozli izohi",
        },
      },
      addFiles: "Fayl qo'shish",
      limitsHelperText: "Matn uzunligi  kamida %{count} harf bo'lishi kerak",
      photoRequired: "Javobingizga kamida bitta rasm yoki fayl ilashing",
      photoViewerHint: "Rasmni sichqoncha g'ildiragi bilan kattalashtirish mumkin",
    },
    type6: {
      title: "Нарисуйте элемент",
      checkButtonText: "Tushunarli!",
    },
    type3: {
      title: "Elementlarni to'g'ri tartibda joylashtiring",
      hint: "Quyida joylashgan elementlarni bu yerga olib o'ting",
    },
    type5: {
      title: "Elementlarni tanlash",
      hint: "Ekranning pastki qismidagi kerakli elementlarni tanlang (tanlash uchun — ularni bosish kifoya)",
    },
    type2: {
      title: "Tushirib qoldirilgan so'zni tanlang",
    },
  },
  Events: {
    headNotice: "Dars vaqti sizning vaqt mintaqangizga qarab ko'rsatiladi",
    title: "Ushbu haftadagi darslar",
    startTime: "Boshlanish vaqti",
    finishTime: "Tugash vaqti",
    group: "Guruh",
    persons: "%{smart_count} kishi |||| %{smart_count} kishi",
    leader: "Olib boruvchi",
    tag: "Toifa",
    joinedCheckbox: "Ro'yxatdan o'tish bilan",
    joined: "Tanlandi:",
    interested: "Ro'yxatdan o'tish",
    registered: "Ro'yxatdan o'tgan",
    enter: "Kirish",
    limitPopupInfo: "Siz darsga ro'yxatdan o'tishning limitini tugatdingiz",
    eventHasStarted: "Dars boshlanib bo'ldi!",
    registrationNotice: "Siz muvaffaqiyatli ro'yxatdan o'tdingiz! Kirish tugmasi %{date_and_time} da faol bo'ladi. Bu vaqtdan keyin siz dars uchun ro'yxatdan o'tishni bekor qila olmaysiz",
    registrationNoticeNoUrl: "Siz muvaffaqiyatli ro'yxatdan o'tdingiz! %{date_and_time} dan keyin siz dars uchun ro'yxatdan o'tishni bekor qila olmaysiz",
    cancelRegistration: "Siz chindan ham ro'yxatdan o'tishni bekor qilmoqchimisiz?",
    calendarLink: "Darsni Google taqvimga qo'shish",
    status_planned: "Rejalashtirilgan",
    status_started: "Boshlandi",
    status_completed_successfully: "Tugatildi",
    status_last_minute_cancellation: "Oxirgi daqiqada bekor qilindi",
    status_late_cancellation: "Kech bekor qilish",
    status_canceled: "Bekor qilindi",
    status_moved: "Ko'chirildi",
  },
  statistic: {
    title: "Statistika",
    points: "ballar",
    phrases: "iboralar",
    missions: "vazifalar",
    words: "lug'at",
    time: "vaqt",
  },
  status: {
    wait_review: "Tekshirishi kutilmoqda",
    on_review: "Tekshiruvda",
    approved: "Qabul qilindi",
    not_approved: "Rad etildi",
    not_approved_allow_update: "Rad etildi (Qaytadan bajrish)",
    ai_reviewed: "Ai tomonidan tekshirildi",
  },
  homeworks: {
    tabName: "Uyga vazifalar",
    todo: "Bajarish uchun",
    done: "Bajarilganlar",
    topic: "Mavzu",
    lesson: "Dars",
    onlyInMobileApp: "Faqat mobil ilovada mavjud",
    todoHomework: "TOPSHIRIQ TEKSHIRUVDA",
    postToDoButton: "Yuborish",
    types: {
      homework_todo: "ToDo",
      exercise: "Exercise",
    },
    waitAIReview: "Iltimos, kuting, sun'iy intellekt javobni tekshirmoqda",
    dontWait: "kutmang",
    checkingHomework: "Uy vazifasini tekshirish",
  },
  exam: {
    popupTitle: "Imtihonli dars",
    popupDescr1: "Bu darsda imtihon mavjud. Avval, barcha qo'shimcha materiallarni o'rganing va shundan keyingina mashqlarni bajarishga o'ting.",
    popupDescr2: `"Mashqlar" yorlig'iga kirganingizdan so'ng, vaqtni hisoblash boshlanadi.`,
    popupDescr3: '"Nazariya" va "Video" yorliqlari imtihon vaqtini hisoblashni boshlamaydi.',
    cancelButton: "Keyingi safar",
    positiveButton: "Tushunarli (%{smart_count} urinish)  |||| Tushunarli (%{smart_count} urinish)",
    questions: "%{smart_count} savol |||| %{smart_count} savollar",
    oneAttempt: "Javob uchun bitta urinish",
    timeLimit: "Vaqt chegarasi: %{limit} minut",
    noPause: "Imtihonni to'xtatib bo'lmaydi",
    progress: "Savol №%{current} dan %{total}",
    closeButton: "Yopish",
    viewButton: "Natijalarni ko'rish",
    retakeButton: "Qayta urinib ko'ring (%{smart_count} urinish)  |||| Qayta urinib ko'ring (%{smart_count} urinish)",
    finishedPopupTitle: "Imtihon natijasi",
    examPassed: "Imtihondan o'tildi",
    examNotPassed: "Imtihondan o'tilmadi",
    waitHomeworks: "%{smart_count} savol tekshiruvda |||| %{smart_count} savol tekshiruvda",
    result: "Sizning natijangiz:",
  },
  subjects: {
    unavailable: "Ayni paytda fan mavjud emas",
  },
  orderStatus: {
    approved: "Qabul qilindi",
    canceled: "Rad etildi",
    pending: "Kutilmoqda",
  },
  notificationsTypes: {
    event: "Dars",
    invoice: "Hisob",
    news: "Yangiliklar",
    homework: "homework",
    homework_todo: "homework_todo",
    type: {
      exercise: "Homework",
      homework_todo: "Homework To do",
    },
  },
  notificationsAlert: {
    subscribe: "Bildirishlarni yoqish",
    unsubscribe: "Bildirishlarni o'chirish",
    instructions: "Manzil satrining chap tomonidagi 🔒qulfni bosing va rasmda ko'rsatilgandek bildirishnomaga ruxsatni o'zgartiring yoki brauzerning umumiy sozlamalarini o'zgartiring.",
    permissionDefault: {
      title: "Bildirishnomalarga obuna bo'ling 🔔",
      body: "UV holatining  dars boshlanishi, yangiliklar, yangi topshiriqqa o'zgarishi haqidagi ogohlantirishlar. Hech qanday reklama yo'q, bildirishnomalar faqat sizning mashg'ulotlaringiz haqida!",
    },
    permissionDenied: {
      title: "Hozir bildirishlar o'chirilgan ❌",
      body: "Siz ilgari bildirishnomalardan voz kechgansiz. Ularsiz siz UV holatining  dars boshlanishi holatiga o'zgarishi haqida o'z vaqtida bilib olomaysiz. Bildirishnomalarni yoqish uchun quyidagi amallarni bajaring:",
    },
    permissionGranted: {
      title: "Hozir bildirishnomalar yoqilgan ✔",
      body: "Siz chindan ham bildirishnomalar olishni xohlamaysizmi? Ularsiz siz UV holatining dars boshlanishi holatiga o'zgarishi haqida o'z vaqtida bila olmaysiz. Bildirishnomalarni o'chirish uchun quyidagi amallarni bajaring:",
    },
  },
  feedbackDialog: {
    sendFeedback: "Fikr-mulohaza yuborish",
    placeholder: "Ta'surotlaringiz bilan bo'lishing",
    defaultInstruction: "Baholash uchun slayderdan foydalaning",
    eventInstruction: "Dars qanday o'tkanini baholang",
    submitError: "Iltimos bahoni tanlang",
    submitSuccess: "Rahmat! Sizning fikr-mulohazangiz muvaffaqiyatli yuborildi",
    wasNotPresent: "Men darsda qatnashmadim",
    dateOfEvent: "Dars sanasi:",
  },
  congratulation: {
    mission: "%{name} sizni tabriklaymiz, vazifa bajarildi!",
    missionTask: {
      title: " 🎉 Tabriklaymiz! %{name} vazifasi bajarildi.",
      content: "Missiyani yakunlash uchun <b>%{need} vazifa</b> qoldi — ajoyib ishni davom eting!",
    },
  },
  accountNotFound: "Ushbu elektron pochta manzili hech qanday ta'lim tashkiloti bilan bog'lanmagan. Maktabingiz ma'muriyati bilan bog'laning",
  demoAccess: "Biznesingiz/maktabingiz uchun SkillzRun-ni sinab ko'rmoqchimisiz? Platformani sinab ko'rish uchun ro'yxatdan o'ting",
  structure: "Tuzilishi",
  version: {
    message: "Ilovaning yangi versiyasi mavjud. Yangilash uchun sahifani yangilang",
    button: "Yuklash",
  },
  missions: {
    title: "Vazifalar",
    startButton: "Missiyani boshlang",
    missionStarted: "Missiya boshlandi %{started}",
    started: "Missiya boshlandi!",
    tasks: {
      title: "Vazifa tafsilotlari",
    },
  },
  productCatalog: {
    title: "Mahsulot katalogi",
    coinBalance: "Sizning balansingiz:",
    notEnoughCoins: "Yeterli tangalar yo'q",
    order: "Buyurtma",
    orderConfirmation: "Buyurtma tasdig'i",
    price: "Narxi:",
    remaining: "Qolgan:",
    instructionForForm: "Buyurtmangizni qayta ishlashni tezlashtirish uchun yetkazib berish ma'lumotlarini to'ldiring.",
    address: "Manzil",
    thankText: "Rahmat! Buyurtmangiz qabul qilindi.",
    pleaseWait: "Iltimos, biroz kuting, menejer tez orada siz bilan bog'lanadi.",
    pleaseWaitPersona: "SMS xabarni kuting. Sizga yuk xati raqami yuboriladi.",
    thankTextOffer: "Rahmat! Xaridingiz muvaffaqiyatli amalga oshirildi.",
    contentAvailableText: "Kontent allaqachon mavjud — hoziroq foydalanishingiz mumkin.",
    deliveryAddress: "Yetkazib berish manzilingizni kiriting",
    helperText: "Iltimos, Nova Poshta/Ukrposhta manzili yoki shahri hamda filial raqamini to'liq ko'rsating.",
    deliveryOptions: "Buyurtma qabul qilingach, yetkazib berish variantlari menejer bilan tasdiqlanadi.",
    validationPhoneFormat: "Telefon raqami 10 ta raqamdan iborat bo'lishi va 0 bilan boshlanishi kerak.",
    recipientNameLabel: "F.I.Sh.",
    recipientNameRequired: "Iltimos, qabul qiluvchining ismini kiriting.",
    npCityRequired: "Iltimos, yetkazib berish shahrini tanlang.",
    npWarehouseRequired: "Iltimos, Nova Poshta bo'limini tanlang.",
    npCityLabel: "Nova Poshta shahri",
    npCityPlaceholder: "Shahar nomini yozishni boshlang",
    npCitySearching: "Shaharlar qidirilmoqda...",
    npCitySelectHint: "Rö'yxatdan shaharni tanlang",
    npCityTypeHint: "Shahar nomini yozishni boshlang (kamida 3 ta belgi)",
    npBranchTypeDepartments: "Bo'limlar",
    npBranchTypePostomats: "Paket avtomatlari",
    npWarehouseLabel: "Nova Poshta bo'limi",
    npWarehousePlaceholder: "Bo'limni tanlang",
    npWarehouseLoading: "Bo'limlar yuklanmoqda...",
    npWarehouseSelectHint: "Rö'yxatdan bo'limni tanlang",
    npWarehouseEmpty: "Bu shahar uchun bo'limlar topilmadi",
    npWarehouseCityFirst: "Avval shaharni tanlang",
    inProcessing: "Qayta ishlashda",
    purchased: "Xarid qilindi",
    oneTimeAlreadyPurchased: "Bu mahsulot allaqachon sotib olingan",
  },
  companyReviewTitle: "Maktabimizni do'stingiz yoki tanishingizga tavsiya qilishingiz qanchalik ehtimol?",
  companyReviewText: '1 dan 10 gacha shkala bo\'yicha baholang, bu erda 1 "umuman ehtimoli yo\'q" degani va 10 "juda ehtimol" deganidir',
  subjectReviewTitle: "Ushbu kursni platformada o'rganish siz uchun qanchalik qiziqarli edi?",
  subjectReviewText: '1 dan 10 gacha shkala bo\'yicha baholang, bu erda 1 "umuman qiziqarli emas" degani va 10 "juda qiziqarli" deganidir',
  lessonsCount_one: "%{smart_count} dars",
  lessonsCount_few: "%{smart_count} darslar",
  lessonsCount_many: "%{smart_count} darslar",
  policySettings: {
    termsAndConditions: "Shartlar va qoidalar",
    refund: "Maxfiylik siyosati",
  },
  promoCode: "Promo kodi",
  promoInvalid: "Promo kodi haqiqiy emas",
};
